import { Key, useCallback, useState } from "react";
import { Button, getKeyValue } from "@nextui-org/react";
import { AddIcon, EditIcon } from "@/assets/icons/admin";
import EditPrivilegeView from "./editprivilegeview";
import { useGetAllRoles } from "@/services/admin.service";
import { Role } from "@/types";
import Datatable from "@/components/tables/datatable";

interface GroupPrivilegeListProps {
  onTabChange: (group: string) => void;
}

const fields = [{ label: "Group Name", value: "name" }];

const columns = [
  { key: "name", label: "Group Name" },
  { key: "totalMembers", label: "Total Member" },
  { key: "action", label: "Action" },
];

const GroupPrivilegeList = ({ onTabChange }: GroupPrivilegeListProps) => {
  const query = useGetAllRoles;

  const [isEditingGroupPrivilege, setIsEditingGroupPrivilege] = useState(false);
  const [itemData, setItemData] = useState<Role | undefined>(undefined);

  const handleEditGroupPrivilegeClick = (item: Role) => {
    setIsEditingGroupPrivilege(true);
    setItemData(item);
  };

  const handleEditGroupPrivilegeCancel = () => {
    setIsEditingGroupPrivilege(false);
  };

  const renderCell = useCallback((data: any[], item: any, columnKey: Key) => {
    switch (columnKey) {
      case "totalMembers":
        return (
          <div
            className="tb-data-blue cursor-pointer"
            onClick={() => onTabChange(item.id)}
          >
            {item?._count?.users ? item?._count?.users : 0}
          </div>
        );
      case "action":
        return (
          <Button
            onClick={() => handleEditGroupPrivilegeClick(item)}
            isIconOnly
            className="transparent-bg h-auto w-auto"
          >
            <EditIcon />
          </Button>
        );
      default:
        return (
          <div className="font-normal">
            {getKeyValue(item, columnKey as string) || "-"}
          </div>
        );
    }
  }, []);

  return (
    <div>
      {isEditingGroupPrivilege ? (
        <>
          {
            <EditPrivilegeView
              onCancel={handleEditGroupPrivilegeCancel}
              itemData={itemData}
            />
          }
        </>
      ) : (
        <div>
          <div>
            <div>
              <div className="font-ubuntu text-center text-2xl font-semibold text-white sm:float-left">
                <p className="justify-center text-sm sm:text-lg md:text-lg lg:text-lg">
                  Group Privilege List
                </p>
              </div>
              {/* Hidden in below sm screens */}
              <Datatable
                columns={columns}
                renderCell={renderCell}
                query={query}
                customQueryFilter={{}}
                customFilters={[]}
                searchFields={fields}
                hideSearchKey
                customActions={[
                  <Button
                    onClick={() => {
                      setItemData(undefined);
                      setIsEditingGroupPrivilege(true);
                    }}
                    className="admin-common-button-gradient font-ubuntu float-right ml-96 ms-auto rounded-md text-base font-bold"
                  >
                    <AddIcon />
                    Add New Group Privilege
                  </Button>,
                ]}
              />
              <div className="hidden sm:flex md:flex lg:flex xl:flex 2xl:flex"></div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default GroupPrivilegeList;
